import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { materialTableTheme } from '../../../shared/utils/smartutils';

const PendingRecordAll = ({ t, onChange, checked }) => {
  return (
    <div className="pendency-all">
      <div>
        <ThemeProvider theme={materialTableTheme}>
          <Checkbox onChange={onChange} checked={checked} />
        </ThemeProvider>
      </div>
      <div>
        <p className="pendency-all-title">{t('general.select-all')}</p>
      </div>
    </div>
  );
};

PendingRecordAll.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};

export default withTranslation('common')(PendingRecordAll);
